import { useEffect, useRef, useState } from 'react';

import AppState from '@/js/AppState';
import clsx from 'clsx';
import Loader from 'react-sdk/components/Loader/Loader';
import classes from './Sokoban.module.css';
import { set } from 'mobx';

const Sokoban = ({level, onFinished }) => {
  const elementRef = useRef(null)
  const [loaded, setLoaded] = useState(false);
  
  const [refreshToken, setRefreshToken] = useState(0);

  // SOKOBAN USE EFFECT INITIAL
  useEffect(() => {

    AppState.reaxe_api.registerModule("sokoban", (event, params) => {
      if(event === "completed") {       
        let {score} = params // pas sur que ca serve
          if(onFinished) onFinished(score)
      }
    })
    
    //a voir pour les levels
    AppState.reaxe_api.toHaxe("sokoban", "launch", {configId : level}, () => setLoaded(true) )
    AppState.mapVisible = false;
    
    
    setTimeout(() => {
      if (AppState.haxeCanvas.parentElement)
        AppState.haxeCanvas.parentElement.removeChild(AppState.haxeCanvas)
      elementRef.current.append(AppState.haxeCanvas)
    }, 50)
    
    
    // appelé à la fermeture du composant
    return () => {
      AppState.reaxe_api.toHaxe("sokoban", "delete", null, 
        () => {
          AppState.mapVisible = true;
          setLoaded(false)
          AppState.reaxe_api.registerModule("sokoban", null)
        }
      )
    }

  }, []);

  return (
    <div className={clsx(classes.Sokoban, loaded && classes.loaded)} ref={elementRef} >
    {!loaded &&
    <div className={classes.loader}>
      <Loader />
    </div>
    }
  </div>
  );
};

export default Sokoban;
